<template>
  <body class="body1">
  <div class="bg1">
    <img src="../model/Images/bg11.jpg" class="bg-img" style="object-fit: cover;">
  </div>
  <div class="container">
    <div class="title" style="font-size:45px;position: absolute;margin-top: -6%;margin-left: 3%">瀚洋电信统一认证管理平台</div>
    <br>
    <br>
    <br>
    <div style="background-color: rgba(248,246,246,0.3);display: inline-block;padding: 20px 15px;border-radius: 6px;margin-top: 10%">
      <div class="box-width"><input class="txt" type="text" placeholder="请输入账号" v-model="loginForm.loginName" clearable></div>
      <div class="box-width"><input class="txt" :type="this.registration_data.pwdType" placeholder="请输入密码" on-change="password" v-model="loginForm.password" clearable>
        <img :src="this.registration_data.src" @click="changeType()" style="position:absolute;margin-left:-1cm;margin-top:0.26cm;width: 30px;height: 20px"/>
      </div>
      <div>
        <el-switch v-model="rememberMeStatus"
                      active-color="#63B8FF"
                      inactive-color="#DBDBDB">
        </el-switch>&nbsp;&nbsp;&nbsp;
        <span style="color: #e2dfdf;font-size: 13px">三天之内免登陆</span>
      </div>
      <div class="box-width"><button class="btnNew btnNew-login" @click="login">登录</button></div>
    </div>
  </div>
  <div class="footer">
    <div style="font-size: 14px;margin-top: 6px;text-align: center;color: #fff">Tontron 2022 version 1.01</div>
    <!--    <a class="a-storage" href="#">绑定云盘</a><br /><br />-->
  </div>
  </body>
</template>

<script>
import { login } from '../api/login'
// import axios from 'axios'
import { mapMutations } from 'vuex'
export default {
  name: 'Welcome',
  data () {
    return {
      msg: '瀚洋统一认证门户',
      loginForm: {
        loginName: this.getLocalStorage('loginName'),
        password: '',
        saveFlag: ''
      },
      error: {
        loginName: '',
        password: ''
      },
      rememberMe: this.rememberMeStatus ? 60 * 60 * 24 * 3 * 1000 : 1000 * 300,
      rememberMeStatus: false,
      registration_data: {
        pwdType: 'password',
        src: require('../assets/colse_eyes.png')
      }
    }
  },
  created () {
  },
  methods: {
    ...mapMutations(['changeLogin']),
    login () {
      let _this = this
      _this.loginForm.saveFlag = _this.rememberMeStatus ? 1 : 0
      if (_this.loginForm.loginName === null || _this.loginForm.password === '') {
        _this.notification('账号或密码不能为空')
      } else {
        login(_this.loginForm).then(res => {
          if (res.token === null) {
            _this.notification('账号或密码错误')
          } else {
            _this.setLocalStorage('loginName', _this.loginForm.loginName)
            _this.setLocalStorage('Authorization', res.token)
            _this.setLocalStorage('loginName', _this.loginForm.loginName)
            _this.rememberMe = _this.rememberMeStatus ? 60 * 60 * 24 * 3 * 1000 : 1000 * 300
            localStorage.setItem('rememberMe', _this.rememberMeStatus ? 60 * 60 * 24 * 3 * 1000 : 1000 * 300)
            _this.$router.push({
              path: '/home'
            })
            _this.successNotification('欢迎使用瀚洋统一管理平台')
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    notification (msg) {
      const h = this.$createElement
      this.$message.error({
        message: h('i', {style: 'color: grey'}, msg),
        center: true
      })
    },
    successNotification (msg) {
      const h = this.$createElement
      this.$message({
        message: h('i', {style: 'color: green'}, msg),
        type: 'success',
        center: true
      })
    },
    setLocalStorage (key, value) {
      var curtime = new Date().getTime() // 获取当前时间 ，转换成JSON字符串序列
      var valueDate = JSON.stringify({
        val: value,
        timer: curtime
      })
      try {
        localStorage.setItem(key, valueDate)
      } catch (e) {
        /* if(e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
              console.log("Error: 本地存储超过限制");
              localStorage.clear();
          } else {
              console.log("Error: 保存到本地存储失败");
          } */
        // 兼容性写法
        if (this.isQuotaExceeded(e)) {
          // console.log('Error: 本地存储超过限制')
          localStorage.clear()
        } else {
          // console.log('Error: 保存到本地存储失败')
        }
      }
    },
    isQuotaExceeded (e) {
      var quotaExceeded = false
      if (e) {
        if (e.code) {
          switch (e.code) {
            case 22:
              quotaExceeded = true
              break
            case 1014: // Firefox
              if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                quotaExceeded = true
              }
              break
          }
        } else if (e.number === -2147024882) { // IE8
          quotaExceeded = true
        }
      }
      return quotaExceeded
    },
    getLocalStorage (key, exp) {
      exp = localStorage.getItem('rememberMe')
      if (exp == null) {
        exp = localStorage.setItem('rememberMe', 1000 * 300)
      }
      // 三天的秒数
      // console.log('exp' + exp)
      if (localStorage.getItem(key)) {
        var vals = localStorage.getItem(key) // 获取本地存储的值
        try {
          var dataObj = JSON.parse(vals)
        } catch (e) {
          localStorage.removeItem('Authorization')
          localStorage.removeItem('loginName')
        } // 将字符串转换成JSON对象
        // 如果(当前时间 - 存储的元素在创建时候设置的时间) > 过期时间
        // console.log(new Date().getTime() + '-' + dataObj.timer + '>' + exp)
        var isTimed = (new Date().getTime() - dataObj.timer) > exp
        if (isTimed) {
          // console.log('存储已过期')
          // localStorage.removeItem(key)
          return null
        } else {
          var newValue = dataObj.val
        }
        return newValue
      } else {
        return null
      }
    },
    changeType () {
      this.registration_data.pwdType = this.registration_data.pwdType === 'password' ? 'text' : 'password'
      this.registration_data.src = this.registration_data.src === require('../assets/colse_eyes.png') ? require('../assets/open_eyes.png') : require('../assets/colse_eyes.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../model/Css/public.css";
  @import "../model/Css/drop-down.css";
  #poster {
    background:url("../assets/background.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
  .el-radio.el-radio__label {
    font-size: 14px;
    padding-left: 100px;
  }
  body{
    margin: 0px;
    padding: 0;
    /*.el-radio{*/
    /*  .el-radio__input.is-checked .el-radio__inner{*/
    /*    background: #d4492c !important;*/
    /*    border-color: #d43547 !important;*/
    /*  }*/
    /*  .el-radio__input.is-checked+.el-radio__label{*/
    /*    color: #d43d1d !important;*/
    /*  }*/
    /*  .el-radio__label {*/
    /*    font-size: 14px;*/
    /*    padding-left: 100px;*/
    /*  }*/
    /*}*/
  }
  .Welcome{
    margin: auto;
    padding: 0;
    position: relative;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: rgba(129, 244, 233, 0.29);
    margin-top: 100px;
  }

  .login{
    margin-top: 200px;
  }
  .input_style{
    width: 200px;
    margin-bottom: 10px;
  }
  .login_style{
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue